import axios from 'axios';
import { Chart, HotIssue, Category } from '../types';

// 환경에 따른 API 기본 URL 설정
const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:8081/api' 
  : '/api'; 

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
console.log(process.env.NODE_ENV);
console.log(process.env.REACT_APP_AUTH_TOKEN);
// 개발 환경에서만 .env(.env.local/.env.development)의 토큰을 기본 헤더에 설정
if (process.env.NODE_ENV === 'development') {
  const devToken = process.env.REACT_APP_AUTH_TOKEN;
  if (devToken) {
    api.defaults.headers.common['Authorization'] = `Bearer ${devToken}`;
  }
}

export const chartApi: {
  getAllCharts: () => Promise<Chart[]>;
  getChart: (id: number) => Promise<Chart>;
  getChartsByCategory: (category: string) => Promise<Chart[]>;
  getRecentCharts: () => Promise<Chart[]>;
  searchCharts: (query: string) => Promise<Chart[]>;
  getAllCategories: () => Promise<any[]>;
} = {
  // 모든 차트 조회
  getAllCharts: async (): Promise<Chart[]> => {
    const response = await api.get('/charts');
    return response.data;
  },

  // 특정 차트 조회
  getChart: async (id: number): Promise<Chart> => {
    const response = await api.get(`/charts/${id}`);
    return response.data;
  },

  // 카테고리별 차트 조회
  getChartsByCategory: async (category: string): Promise<Chart[]> => {
    const response = await api.get(`/charts/category/${category}`);
    return response.data;
  },

  // 최근 차트 조회
  getRecentCharts: async (): Promise<Chart[]> => {
    const response = await api.get('/charts/recent');
    return response.data;
  },

  // 차트 검색
  searchCharts: async (query: string): Promise<Chart[]> => {
    const response = await api.get(`/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  // 카테고리 목록 조회 (DB 기반)
  getAllCategories: async (): Promise<any[]> => {
    const response = await api.get('/categories');
    return response.data;
  },
};

export const categoryApi = {
  // 카테고리 목록 조회
  getCategories: async (): Promise<Category[]> => {
    const response = await api.get('/categories');
    return response.data;
  },
  // 카테고리 목록 조회 (DB 기반)
  getAllCategories: async (): Promise<any[]> => {
    const response = await api.get('/categories');
    return response.data;
  },
};

export const hotIssueApi = {
  // 핫이슈 조회
  getHotIssues: async (): Promise<HotIssue[]> => {
    const response = await api.get('/hot-issues');
    return response.data;
  },
  // 핫이슈별 순위데이터 조회
  getHotIssueItems: async (id: number): Promise<any[]> => {
    const response = await api.get(`/hot-issues/${id}/items`);
    return response.data;
  },
}; 